import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../utils/cn"

const featureCardVariants = cva(
    "relative flex flex-col justify-start border p-4 shadow-brutal-md transition-all",
    {
        variants: {
            variant: {
                default: "border-ink bg-gold/90 text-foreground",
                purple: "border-ink bg-[#ae5dffbc] text-foreground",
                important: "border-brutal-thick border-ink bg-[#ff611dbc] pl-2 shadow-[0px_0px_10px_2px_rgba(255,111,0,0.9),5px_10px_0px_0px_rgba(0,0,0,0.7)] text-[1.5rem] font-bold text-foreground",
                neonPink: "border-brutal-thick border-ink bg-[#ff1dc3bc] pl-2 shadow-[0px_0px_10px_2px_rgba(255,0,230,0.9),5px_10px_0px_0px_rgba(0,0,0,0.7)] text-[1.5rem] font-bold text-foreground",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface FeatureCardProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof featureCardVariants> {
    asChild?: boolean
}

const FeatureCard = React.forwardRef<HTMLDivElement, FeatureCardProps>(
    ({ className, variant, style, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(featureCardVariants({ variant, className }))}
                style={style}
                {...props}
            />
        )
    }
)
FeatureCard.displayName = "FeatureCard"

export { FeatureCard, featureCardVariants }










